<script lang="ts">
    // generates a random character from U+25A0 to U+25FF
    import { writable } from 'svelte/store';
    import { onMount } from 'svelte';

    export let length: number = 5;

    function generateRandomSymbol() {
        return String.fromCharCode(Math.floor(Math.random() * 96) + 9632);
    }

    const thought = writable<string>(
        Array(length).fill(null).map(generateRandomSymbol).join('')
    );

    onMount(() => {
        const interval = setInterval(() => {
            thought.update((current) => {
                // replace a random character with a new one
                const index = Math.floor(Math.random() * length);
                const newSymbol = generateRandomSymbol();
                return (
                    current.slice(0, index) +
                    newSymbol +
                    current.slice(index + 1)
                );
            });
        }, 100);

        return () => {
            clearInterval(interval);
        };
    });
</script>

{$thought}
